export class UserPreference {
    key: string;
    value: string;
}